import { Directive } from '@angular/core';
import { StateSrefBase } from './state-sref.base';

@Directive({
    selector: 'button[fiStateSref]',
    exportAs: 'fiStateSref',
    standalone: false,
})
export class StateSrefButtonDirective extends StateSrefBase {}
